module.exports = __webpack_public_path__ + "img/audioMute.9d548110.svg";